import React from 'react';

/** Result of a validated-select (activation) attempt. */
export interface AccountActivateResult {
  ok: boolean;
  error?: string;
}

/**
 * Per-instance callbacks a host may supply to take over what selecting an account
 * *means* for its resource. The framework's default is to record the selection on
 * the store; a host that has to persist it — and can refuse — implements these
 * instead.
 *
 * The static half of a resource's customisation lives on `AccountResourceAdapter`,
 * which is module-level. These are bound to a mounted host, so they arrive through
 * context rather than through the store's config. Absent for source and destination
 * accounts, where the framework's default select applies.
 */
export interface AccountResourceActions {
  /** Validated-select: activate an account. Resolves ok=false with a reason on 400/404. */
  activate: (accountId: string) => Promise<AccountActivateResult>;
  /** Reflect the active account having been dropped (deleted / link cleared). */
  onDisconnected: () => void;
  /** Close the host's account modals. */
  close: () => void;
}

export const AccountResourceActionsCtx = React.createContext<AccountResourceActions | undefined>(
  undefined,
);

export const useAccountResourceActions = (): AccountResourceActions | undefined =>
  React.useContext(AccountResourceActionsCtx);
